// @webtoon/psd
// Copyright 2021-present NAVER WEBTOON
// MIT License

/**
 * Color depth (# of bits per channel) of a PSD file.
 * @alpha
 */
export enum Depth {
  One = 1,
  Eight = 8,
  Sixteen = 16,
  ThirtyTwo = 32,
}
